// 弹框选中态 + 应用语义(owner 决策:6h 自动测速总是覆盖,手动=临时钉 6h)。
// 设计:docs/superpowers/specs/2026-07-13-resource-node-switch-client-design.md §3.4
import { useCallback, useSyncExternalStore } from 'react'
import type { CdnNode } from '../components/modals/node-test-modal'
import { runAutoSelect } from './resource-node-auto'
import { clearToAuto, getPref, setPref, subscribe } from './resource-node-pref'

export function useNodePref(nodes: CdnNode[]) {
  const pref = useSyncExternalStore(subscribe, getPref, () => null)
  const currentNodeId = pref?.domain ? pref.node_id : 'auto'

  const applyNode = useCallback(
    (id: string) => {
      if (id === 'auto') {
        clearToAuto()
        void runAutoSelect() // 回自动档立即后台重测
        return
      }
      const n = nodes.find((x) => x.id === id)
      if (!n?.domain) return
      setPref({ node_id: id, domain: n.domain, tested_at: Date.now() })
    },
    [nodes],
  )

  return { currentNodeId, applyNode }
}
